import React from 'react'
import { CopyToClipboard } from 'react-copy-to-clipboard';
import Icon from '../../../../elements/Icon/Icon';
import txStatus from './dictionaries/txStatus';
import classes from './style.module.css'

import { toast } from 'react-toastify';

const getAddressUrl = (currencyCode) => {
    switch (currencyCode) {
        case 'BTC':
        case 'USDT':
            return 'https://blockchair.com/bitcoin/address/'
        case 'BTG':
            return 'https://explorer.bitcoingold.org/insight/address/'
        case 'BCH':
            return 'https://blockchair.com/bitcoin-cash/address/'
        case 'BSV':
            return 'https://blockchair.com/bitcoin-sv/address/'
        case 'XMR':
            return 'https://blockchair.com/monero/address/'
        case 'LTC':
            return 'https://blockchair.com/litecoin/address/'
        case 'TRX':
        case 'TRX_USDT':
        case 'TRX_BTT':
            return 'https://tronscan.org/#/address/'
        case 'DOGE':
            return 'https://blockchair.com/dogecoin/address/'
        case 'XVG':
            return 'https://verge-blockchain.info/address/'
        case 'XRP':
            return 'https://blockchair.com/ripple/address/'
        case 'ETH':
        case 'ETH_USDT':
        case 'ETH_TRUE_USD':
        case 'ETH_USDC':
        case 'ETH_PAX':
        case 'ETH_DAIM':
        case 'ETH_OKB':
        case 'ETH_MKR':
        case 'ETH_KNC':
        case 'ETH_BNT':
        case 'ETH_UAX':
            return 'https://etherscan.io/address/'
        case 'BNBSMART':
            return 'https://bscscan.com/address/'
        default:
            return 'https://trusteeglobal.com/'
    }
}

const getHashUrl = (currencyCode) => {
    switch (currencyCode) {
        case 'BTC':
        case 'USDT':
            return 'https://blockchair.com/bitcoin/transaction/'
        case 'BTG':
            return 'https://explorer.bitcoingold.org/insight/tx/'
        case 'BCH':
            return 'https://blockchair.com/bitcoin-cash/transaction/'
        case 'BSV':
            return 'https://blockchair.com/bitcoin-sv/transaction/'
        case 'XMR':
            return 'https://blockchair.com/monero/transaction/'
        case 'LTC':
            return 'https://blockchair.com/litecoin/transaction/'
        case 'TRX':
        case 'TRX_USDT':
        case 'TRX_BTT':
            return 'https://tronscan.org/#/transaction/'
        case 'DOGE':
            return 'https://blockchair.com/dogecoin/transaction/'
        case 'XVG':
            return 'https://verge-blockchain.info/tx/'
        case 'XRP':
            return 'https://blockchair.com/ripple/transaction/'
        case 'ETH':
        case 'ETH_USDT':
        case 'ETH_TRUE_USD':
        case 'ETH_USDC':
        case 'ETH_PAX':
        case 'ETH_DAIM':
        case 'ETH_OKB':
        case 'ETH_MKR':
        case 'ETH_KNC':
        case 'ETH_BNT':
        case 'ETH_UAX':
            return 'https://etherscan.io/tx/'
        case 'BNBSMART':
            return 'https://bscscan.com/tx/'
        default:
            return 'https://trusteeglobal.com/'
    }
}

const ItemTable = (props) => {

    const { item, key, keysArray, mode, moreInfoButtonHandler, setState, state } = props


    const data = {
        id: item.id,
        logCashback: item.logCashback,
        logParent: item.logParent,
        logWallet: item.logWallet,
        logDate: item.logDate,
        logModel: item.logModel,
        logPlatform: item.logPlatform,
        logVersion: item.logVersion,
        logTester: item.logTester,
        processedLog: item.processedLog,
        isProcessing: item.isProcessing,
        processedStatus: item.processedStatus,
        pushIsProcessing: item.pushIsProcessing,
        pushLocale: item.pushLocale,
        pushProcessedTime: item.pushProcessedTime,
        pushSetting: item.pushSetting,
        pushStatus: item.pushStatus,
        updatedAt: item.updatedAt,
        processedTime: item.processedTime,
        txRaw: item.txRaw,
        txAddressValue: item.txAddressValue,
        setInputsOutputs: item.setInputsOutputs
    }

    return (
        <tr key={key}>
            {
                keysArray.map(key => {
                    if (key === 'logCashback') {
                        return (
                            <td>
                                <div className={classes.row} style={{ cursor: 'pointer' }} onClick={() => moreInfoButtonHandler(data)} >
                                    <div style={{ wordBreak: !item[key] && 'break-all' }}>
                                        {item[key] || item['logWallet'] || 'nothing'}
                                    </div>
                                    <div className={classes.icon}>
                                        <Icon icon={'INFO'} size={20} />
                                    </div>
                                    <div className={classes.icon} style={{ padding: 10 }} onClick={(e) => {
                                        e.stopPropagation();
                                        setState({
                                            ...state,
                                            cashbackToken: item.logCashback
                                        })
                                        const btn = document.getElementById('search')
                                        setTimeout(async () => btn.click(), 0)
                                    }}>
                                        <Icon icon={'FILTER'} viewBox={'0 0 18 18'} size={18} />
                                    </div>
                                </div>
                                {item.txAddressValue ?
                                    <div style={{ paddingTop: 10 }}>
                                        {'Сумма транзы: '}
                                        <div className={classes.row}>
                                            {item.txAddressValue}
                                        </div>
                                    </div>
                                    : ''}
                            </td>
                        )
                    }
                    if (key === 'txAddress') {
                        return (
                            <td>
                                <>
                                    {item['txAddressFrom'] ?
                                        <>
                                            {'От: '}
                                            <div className={classes.row}>
                                                <a href={getAddressUrl(item.txCurrencyCode) + item['txAddressFrom']} style={{ marginLeft: 5 }} target="_blank" rel={'noopener noreferrer'}>
                                                    {`${item['txAddressFrom'].toString().slice(0, 6)}...${item['txAddressFrom'].toString().slice(-6)}`}
                                                </a>
                                                <CopyToClipboard text={item['txAddressFrom']} onCopy={() => toast.dark('Адрес отправителя скопировано в буфер обмена')}>
                                                    <div className={classes.icon}>
                                                        <Icon icon={'COPY'} size={24} color={'#404040'} />
                                                    </div>
                                                </CopyToClipboard>
                                                <div className={classes.icon} style={{ padding: 10 }} onClick={() => {
                                                    setState({
                                                        ...state,
                                                        fromAddress: item.txAddressFrom
                                                    })
                                                    const btn = document.getElementById('search')
                                                    setTimeout(async () => btn.click(), 0)
                                                }}>
                                                    <Icon icon={'FILTER'} viewBox={'0 0 18 18'} size={18} />
                                                </div>
                                            </div>
                                        </> : ''}
                                    {item['txAddressTo'] ?
                                        <div style={{ paddingTop: 10 }}>
                                            {'Кому: '}
                                            <div className={classes.row}>
                                                <a href={getAddressUrl(item.txCurrencyCode) + item['txAddressTo']} style={{ marginLeft: 5 }} target="_blank" rel={'noopener noreferrer'}>
                                                    {`${item['txAddressTo'].toString().slice(0, 6)}...${item['txAddressTo'].toString().slice(-6)}`}
                                                </a>
                                                <CopyToClipboard text={item['txAddressTo']} onCopy={() => toast.dark('Адрес получателя скопировано в буфер обмена')}>
                                                    <div className={classes.icon}>
                                                        <Icon icon={'COPY'} size={24} color={'#404040'} />
                                                    </div>
                                                </CopyToClipboard>
                                                {/* <div className={classes.icon} style={{ padding: 10 }}>
                                                    <Icon icon={'FILTER'} viewBox={'0 0 18 18'} size={18} />
                                                </div> */}
                                            </div>
                                        </div> : ''}
                                </>
                            </td>
                        )
                    }
                    if (key === 'txHashes') {
                        return (
                            <td style={{ wordBreak: 'break-all', minWidth: 200, maxWidth: 250 }}>
                                <>
                                    {item['txHash'] ?
                                        <>
                                            {'Хеш: '}
                                            <div className={classes.row}>
                                                <a href={getHashUrl(item.txCurrencyCode) + item['txHash']} style={{ marginLeft: 5 }} target="_blank" rel={'noopener noreferrer'}>
                                                    {`${item['txHash'].toString().slice(0, 6)}...${item['txHash'].toString().slice(-6)}`}
                                                </a>
                                                <CopyToClipboard text={item['txHash']} onCopy={() => toast.dark('Хеш транзакции скопировано в буфер обмена')}>
                                                    <div className={classes.icon}>
                                                        <Icon icon={'COPY'} size={24} color={'#404040'} />
                                                    </div>
                                                </CopyToClipboard>
                                                <div className={classes.icon} style={{ padding: 10 }} onClick={() => {
                                                    setState({
                                                        ...state,
                                                        txHash: item.txHash
                                                    })
                                                    const btn = document.getElementById('search')
                                                    setTimeout(async () => btn.click(), 0)
                                                }}>
                                                    <Icon icon={'FILTER'} viewBox={'0 0 18 18'} size={18} />
                                                </div>
                                            </div>
                                        </>
                                        :
                                        <div style={{ fontStyle: 'italic', wordBreak: 'break-all' }}>
                                            {item.processedLog}
                                        </div>}
                                    {item['txRbf'] ?
                                        <div style={{ paddingTop: 10 }}>
                                            {'RBF: '}
                                            <div className={classes.row}>
                                                <a href={getHashUrl(item.txCurrencyCode) + item['txRbf']} style={{ marginLeft: 5 }} target="_blank" rel={'noopener noreferrer'}>
                                                    {`${item['txRbf'].toString().slice(0, 6)}...${item['txRbf'].toString().slice(-6)}`}
                                                </a>
                                                <CopyToClipboard text={item['txRbf']} onCopy={() => toast.dark('Хеш транзакции скопировано в буфер обмена')}>
                                                    <div className={classes.icon}>
                                                        <Icon icon={'COPY'} size={24} color={'#404040'} />
                                                    </div>
                                                </CopyToClipboard>
                                                {/* <div className={classes.icon} style={{ padding: 10 }} onClick={() => {
                                                    setState(state => ({
                                                        ...state,
                                                        txHash: item.txRbf
                                                    }))
                                                    const btn = document.getElementById('search')
                                                    setTimeout(async () => btn.click(), 0)
                                                }} >
                                                    <Icon icon={'FILTER'} viewBox={'0 0 18 18'} size={18} />
                                                </div> */}
                                            </div>
                                        </div>
                                        : ''}
                                </>
                            </td>
                        )
                    }

                    if (key === 'txRaw') {
                        return (
                            <td>
                                <CopyToClipboard text={item[key]} onCopy={() => toast.dark('txRaw скопировано в буфер обмена')}>
                                    <div className={classes.icon} style={{ padding: 5 }}>
                                        <Icon icon={'COPY'} size={24} color={'#404040'} />
                                    </div>
                                </CopyToClipboard>
                            </td>
                        )
                    }

                    if (key === 'createdAt') {
                        let value = item[key] ? item[key].replace(/[a-zA-Z]/g, ' ') : ''
                        value = value.toString().split(' ')
                        return (
                            <td>
                                {item[key] ?
                                    <div className={classes.column}>
                                        <div>{value[0]}</div>
                                        <div>{value[1]}</div>
                                    </div>
                                    : ''}
                            </td>
                        )
                    }

                    if (key === 'txCurrencyCode') {
                        const value = item[key] && !mode.includes(item[key]) ? item[key] : ''

                        if (!value) return (<td></td>)
                        const data = {
                            txCurrencyCode: item.txCurrencyCode,
                            txToken: item.txToken
                        }
                        return (
                            <td>
                                {value ?
                                    <div className={classes.row} style={{ cursor: 'pointer' }} onClick={() => moreInfoButtonHandler(data)}>
                                        {value}
                                        <div className={classes.icon}>
                                            <Icon icon={'INFO'} size={20} />
                                        </div>
                                    </div>
                                    : null}
                            </td>
                        )
                    }

                    if (key === 'selectedFee') {
                        const value = item[key]
                        // const obj = JSON.parse(value)
                        return (
                            <td>
                                {/* <div style={{ wordBreak: 'break-all', width: 450 }}>
                                    {Object.entries(obj).map((item) => {
                                        return (
                                            <div style={{  }}>
                                                <b><i>{item[0] + ':'}</i></b>
                                                {`${JSON.stringify(item[1])}`}
                                            </div>
                                        )
                                    })}
                                </div> */}
                                <div style={{ wordBreak: 'break-all', width: 450 }}>
                                    {value}
                                </div>
                            </td>
                        )
                    }

                    if (key === 'confirmedTime') {
                        let value = item.confirmedTime || item.rbfedTime || item.removedTime || null

                        return (
                            <td>
                                {value &&
                                    <div style={{ color: item.confirmedTime ? 'green' : item.rbfedTime ? 'orange' : item.removedTime ? 'red' : '' }}>
                                        {value}
                                    </div>
                                }
                            </td>
                        )
                    }

                    if (key === 'moreInfo') {
                        return (
                            <td>
                                <button onClick={() => moreInfoButtonHandler(data)}>
                                    More info</button>
                            </td>
                        )
                    }

                    if (key === 'txStatus') {
                        return (
                            <td>
                                {txStatus[item.txStatus] || item.txStatus}
                            </td>
                        )
                    }

                    return (
                        <td>{item[key]}</td>
                    );
                })
            }
            {window.screen.width < 700 && <td>{txStatus[item.txStatus] || item.txStatus}</td>}
        </tr>
    )
}

export default ItemTable